// The time by vizbi.org's server, not the visitor's clock (Seán, 2026-11-03): /live reveals the
// Zoom link when a session starts, and a participant set her computer's clock forward to see it
// early. The offset is read once per visit from the Date header of a request to vizbi.org (to
// the second; same-origin, as the header isn't readable across origins); until it's known,
// isServerTimeKnown is false and nothing that reveals the link changes. If the request fails,
// the visitor's clock is used (a network failure shouldn't keep people out of the meeting).
import {ref} from "vue";
import {DateTime} from "luxon";

export const isServerTimeKnown = ref(false);
let offsetMilliseconds = 0;
let pending = null;

async function fetchOffset() {
  const sentAt = Date.now();
  const response = await fetch(`/?serverTime=${sentAt}`, {method: "HEAD", cache: "no-store"});
  const receivedAt = Date.now();
  const serverAt = Date.parse(response.headers.get("date") || "");
  if (Number.isNaN(serverAt)) return 0;
  return serverAt + 500 - (sentAt + receivedAt) / 2; // the header drops the milliseconds
}

async function applyOffset() {
  offsetMilliseconds = await fetchOffset().catch(() => 0);
  isServerTimeKnown.value = true;
}

// once per visit, however many components ask
export function startServerClock() {
  pending ||= applyOffset();
  return pending;
}

export const getServerNow = () => DateTime.now().plus({milliseconds: offsetMilliseconds});
